"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormTemplateSchemaProperties = exports.FormTemplateSchema = exports.FormTemplateItem = exports.SignatureTemplate = exports.FormTemplateItemOption = exports.FormTemplateItemDisplayTypeEnum = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
const smart_action_schema_1 = require("./smart-action-schema");
const FormTemplateStatusEnum = zod_1.z.enum(["active", "deleted", "inactive"]);
exports.FormTemplateItemDisplayTypeEnum = zod_1.z.enum([
    "select-dropdown",
    "radio-list",
]);
exports.FormTemplateItemOption = zod_1.z.object({
    label: zod_1.z.string().optional(),
    value: zod_1.z.string(),
});
// We are currently storing all dates related to this type as string, probably because
// of the way the Dropboxsign returns this object
exports.SignatureTemplate = zod_1.z.object({
    createdUserId: zod_1.z.string(),
    dateCreated: zod_1.z.string(),
    dateUpdated: zod_1.z.string(),
    serviceData: zod_1.z.object({
        createdDate: zod_1.z.string(),
        editUrl: zod_1.z.string(),
        expiresAt: zod_1.z.string(),
        templateId: zod_1.z.string(),
        updatedDate: zod_1.z.string(),
    }),
    serviceType: zod_1.z.string(),
    signatures: zod_1.z.array(zod_1.z.any()),
    updatedUserId: zod_1.z.string(),
});
exports.FormTemplateItem = zod_1.z.object({
    custom: zod_1.z.any(),
    question: zod_1.z.string(),
    displayType: exports.FormTemplateItemDisplayTypeEnum.optional(),
    options: exports.FormTemplateItemOption.array().optional(),
    signatureTemplate: exports.SignatureTemplate.optional(),
    // TODO Probably enum?
    questionType: zod_1.z.string(),
    required: zod_1.z.boolean().optional(),
    /* TODO some kind of inheritance based on question type,
      where if questionType is digital-signature, file prop is
      present, otherwise not */
    file: zod_1.z.string().or(zod_1.z.null()).or(zod_1.z.any()).optional(),
});
exports.FormTemplateSchema = base_schema_1.BaseSchema.extend({
    title: zod_1.z.string(),
    slug: zod_1.z.string(),
    description: zod_1.z.string().optional(),
    icon: zod_1.z.string(),
    messagingInvite: zod_1.z.boolean().optional(),
    items: zod_1.z.array(exports.FormTemplateItem),
    status: FormTemplateStatusEnum,
    internal: zod_1.z.boolean().optional(),
    smartActions: smart_action_schema_1.SmartActionTemplateSchema.array().optional(),
});
exports.FormTemplateSchemaProperties = {
    collectionName: "form_templates",
    deleteMode: schema_properties_interface_1.DeleteMode.None,
};
//# sourceMappingURL=form-template-schema.js.map